import React, {useEffect} from "react";
import NdsToolsTable from "./NdsToolsTable";
import {useDispatch} from "react-redux";
import {loadNdsItems} from "../../../../actions/ndsActions";
import {loadAllCountries} from "../../../../actions/countriesActions";

export default function NdsToolsContent({}) {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadNdsItems());
        dispatch(loadAllCountries());
    }, []);

     return <div  id="custom-nav-home" role="tabpanel"
                        aria-labelledby="custom-nav-home-tab" style={{ height: '80vh'}}>
        <NdsToolsTable/>
    </div>
};